// teams

const state = {
	teams: [],
	team: {},

};

export default state;